import { Button, Card, Stack, SvgIcon, TextField, Typography } from '@mui/material';
import ArrowLeftIcon from '@untitled-ui/icons-react/build/esm/ArrowLeft';
import ArrowRightIcon from '@untitled-ui/icons-react/build/esm/ArrowRight';
import PropTypes from 'prop-types';
import { FC, useCallback, useRef, useState } from 'react';
import { TeamSubmitData } from 'src/pages/settings/team-information';

interface TeamStepProps {
  onNext?: (data: TeamSubmitData) => void;
  onBack?: () => void;
  team?: TeamSubmitData;
  // ref: any
}

export const TeamStep: FC<TeamStepProps> = (props) => {
  const { onBack, onNext, team, ...other } = props;
  const handleCreateTeam = useCallback(
    (data: TeamSubmitData) => {
      onNext?.(data);
    },
    [onNext],
  );
  const ref = useRef<HTMLFormElement | null>();

  const [teamInformation, setTeamInformation] = useState<{
    name: string;
  }>({ name: '' });

  const handleOnTeamNameChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setTeamInformation((prev) => ({
      ...prev,
      name: event.target.value,
    }));
  }, []);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  return (
    <Stack spacing={3} {...other}>
      <Stack spacing={2}>
        <Card
          sx={{
            alignItems: 'center',
            cursor: 'pointer',
            display: 'flex',
            p: 2,
          }}
        >
          <Stack spacing={2}>
            {/* <Typography variant="subtitle1">Team information</Typography> */}
            <Typography>If you have a registered company write the name or make something up.</Typography>
            <TextField
              fullWidth
              label="Team Name"
              name="name"
              required
              // value={team?.name}
              variant="outlined"
              onChange={handleOnTeamNameChange}
              // onBlur={handleBlur}
              error={Boolean(errorMessage)}
              helperText={errorMessage}
            />
          </Stack>
        </Card>
      </Stack>
      <Stack spacing={2} direction={'row'}>
        <Button
          endIcon={
            <SvgIcon>
              <ArrowLeftIcon />
            </SvgIcon>
          }
          onClick={onBack}
          variant="contained"
        >
          Back
        </Button>
        <Button
          // disabled={!hasSubmitted}
          endIcon={
            <SvgIcon>
              <ArrowRightIcon />
            </SvgIcon>
          }
          onClick={() => {
            if (teamInformation.name) {
              handleCreateTeam(teamInformation);
            } else {
              setErrorMessage('Please enter a team name');
            }
          }}
          variant="contained"
        >
          Next
        </Button>
      </Stack>
    </Stack>
  );
};

TeamStep.propTypes = {
  onBack: PropTypes.func,
  onNext: PropTypes.func,
};
